export const seoDefaults = {
  siteName: 'KAYS & KAYS',
  locale: 'en_AE',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/cd6fe2c1-ea97-4418-a9c9-cf91a0e803ce.jpg',
};

export const homeSeo = {
  title: 'KAYS & KAYS — Family Office for Capital, Culture & Longevity',
  description:
    'KAYS & KAYS is a Dubai-registered family office aligning capital, culture and longevity — curated real estate, media and human performance, built to endure.',
};

export const manuscriptSeo = {
  title: '0/1 — On stillness, action and the recursion of quality | KAYS & KAYS',
  description:
    'Working paper No. 01 from the KAYS & KAYS Research Office on quality as a recursive constant across capital, culture and longevity.',
};

export const legalSeoDescription = (label: string) =>
  `${label} of KAYS & KAYS, operated by KAYS VENTURES FZCO, Dubai Silicon Oasis, Dubai, United Arab Emirates.`;
